import PublicLayout from "../components/PublicLayout";
import { ShieldCheck, EyeOff, FileLock, Mail } from "lucide-react";

export default function PrivacyPage() {
    return (
        <PublicLayout>
            <div className="max-w-[800px] mx-auto px-6 py-16">
                
                {/* Title */}
                <div className="border-b border-[#27272A] pb-6 mb-10">
                    <div className="label-mono text-[#00FF41] mb-2">// policy / security</div>
                    <h1 className="text-3xl font-display font-black tracking-tight text-[#FAFAFA] uppercase">
                        PRIVACY POLICY
                    </h1>
                    <p className="text-[#A1A1AA] text-xs font-mono mt-1 uppercase">
                        Last Revised: June 4, 2026
                    </p>
                </div>

                {/* Core Columns */}
                <div className="space-y-10 text-xs md:text-sm text-[#A1A1AA] leading-relaxed">
                    
                    {/* Section 1: Zero Payload Logging */}
                    <div className="border border-[#27272A] bg-[#0A0A0A] p-6">
                        <div className="flex items-center gap-2 text-[#FAFAFA] font-bold uppercase mb-3">
                            <EyeOff className="w-5 h-5 text-[#00FF41]" />
                            <span>1. Zero Payload Retention</span>
                        </div>
                        <p>
                            We terminate HTTPS packets at our Ingress Relays to resolve routing, handle rate limits, and stream request details to your active inspector socket. **We do not save request or response bodies/headers permanently on disk.**
                        </p>
                        <p className="mt-2">
                            Live requests are piped to your browser dashboard inspector over in-memory WebSockets and disappear when you clear your log panel, disconnect the tunnel, or log out of your session.
                        </p>
                    </div>

                    {/* Section 2: Account and Key Data */}
                    <div>
                        <h2 className="text-sm font-bold text-[#FAFAFA] uppercase mb-3 flex items-center gap-2">
                            <ShieldCheck className="w-4 h-4 text-[#00FF41]" />
                            2. Account & Connection Metadata
                        </h2>
                        <p>
                            To maintain and manage tunnels, we store minimal configuration details on our secure database servers:
                        </p>
                        <ul className="list-disc list-inside space-y-2 mt-2 pl-2">
                            <li>Account profiles (emails, names, encrypted hashed passwords).</li>
                            <li>Tunnel status metadata (reserved subdomains, active port configurations).</li>
                            <li>Secure long-lived API Keys generated by you.</li>
                            <li>Connection logs (timestamps, traffic volumes, IP endpoints) solely used to enforce tier quotas and safeguard relays.</li>
                        </ul>
                    </div>

                    {/* Section 3: Billing and Payments */}
                    <div>
                        <h2 className="text-sm font-bold text-[#FAFAFA] uppercase mb-3 flex items-center gap-2">
                            <FileLock className="w-4 h-4 text-[#FF9900]" />
                            3. Billing and Transactions
                        </h2>
                        <p>
                            Billing services are fully processed and validated through Freemius, our secure, hosted billing provider. We do not store or process your credit card numbers, CVVs, or payment identifiers on SynapseLink systems.
                        </p>
                    </div>

                    {/* Section 4: Contact */}
                    <div className="border-t border-[#27272A] pt-8 mt-12 flex flex-wrap justify-between items-center gap-4">
                        <div>
                            <div className="font-bold text-[#FAFAFA] uppercase text-xs">Questions or Security Audits?</div>
                            <div className="text-[11px] mt-1">Get in touch directly with our support desk.</div>
                        </div>
                        <a href="mailto:support@synapselink.cloud" className="tf-btn flex items-center gap-2 !py-2">
                            <Mail className="w-4 h-4" /> support@synapselink.cloud
                        </a>
                    </div>

                </div>

            </div>
        </PublicLayout>
    );
}
